module.exports = __webpack_public_path__ + "static/media/msg-edit.3514bf0f.png";